<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Administrador | Validación de solicitudes
                <v-spacer />
                <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    placeholder="Buscar (Presione ENTER para comenzar la búsqueda)"
                    hide-details
                    @keydown.enter="getSolicitudServicioPendientes_"
                />
            </v-card-title>

            <!-- <v-data-table
            v-if="1>2"
                :headers="headers"
                :items="items"
                :loading="loading"
                :search="search"
                calculate-widths
                loading-text="Cargando... Por favor espere"
                locale="es-ES"
            >
                <template v-slot:item.acciones="{ item }">
                    <v-btn 
                        small 
                        @click="consultarSolicitud(item)">Consultar</v-btn>
                </template>
            </v-data-table> -->
            <v-data-table
                :headers="headersSS"
                :items="items"
                :loading="loading"
                calculate-widths
                loading-text="Cargando... Por favor espere"
                locale="es-ES"

                sort-by="idExternoServicioPk"
                :sort-desc="true"
                :options.sync="options"
                :server-items-length="numberOfItemsOnServer"
            >
                <template v-slot:item.fechaRegistroDt="{ item }">
                    {{ getDateFormated(item.fechaRegistroDt) }}
                </template>
                <template v-slot:item.acciones="{ item }">
                    <v-btn
                        small
                        @click="consultarSolicitud(item)"
                    >
                        Consultar
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
        <ficha-solicitud-validacion
            :item="itemSelected"
            :dialog="dialog"
            :close-dialog="closeDialog"
            :refresh-table="getSolicitudServicioPendientes_"
        />
        <v-snackbar
            key="snackbar_grid_valid_solic_administrador"
            v-model="snackbarError"
            :bottom="true"
            :multi-line="true"
            color="error"
        >
            {{ textoError }}
            <v-btn
                dark
                text
                @click="snackbarError = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { getSolicitudServicioPendientesPaginated } from "@/api";
import moment from "moment";

export default {
  name: "GridValidacionSolicitudesAdministrador",
  components: {
    FichaSolicitudValidacion: () =>
      import("../../components/molecules/FichaSolicitudValidacion"),
  },
  props: {},
  data () {
    return {
      loading: true,
      snackbarError: false,
      textoError: "",
      headers: [
        { align: "left", text: "Servicio", value: "descripcion" },
        { align: "left", text: "Nombre usuario", value: "nombre" },
        { align: "left", text: "Correo", value: "correo" },
        { align: "center", text: "Núm. Requisitos", value: "numRequisitos" },
        {
          align: "center",
          text: "Núm. Requisitos Validados",
          value: "numRequisitosValidados",
        },
        { align: "center", text: "Estatus", value: "estatus" },
        { align: "center", text: "Acciones", value: "acciones" },
      ],
      headersSS: [
        { align: "left", text: "Servicio", value: "descripcion" },
        {
          align: "left",
          text: "Nombre de la organización y/o razón social",
          value: "organizacion",
        },
        { align: "left", text: "Contacto", value: "contacto" },
        { align: "left", text: "Correo", value: "correo" },
        { align: "left", text: "Campus", value: "campus" },
        { align: "left", text: "R.F.C.", value: "rfc" },
        { align: "left", text: "Fecha Registro", value: "fechaRegistroDt" },
        { align: "center", text: "Núm. Requisitos", value: "numRequisitos" },
        {
          align: "center",
          text: "Núm. Requisitos Validados",
          value: "numRequisitosValidados",
        },
        { align: "center", text: "Estatus", value: "estatus" },
        { align: "center", text: "Acciones", value: "acciones" },
      ],
      items: [],
      search: "",
      dialog: false,
      itemSelected: {},

      options: {},
      numberOfItemsOnServer: 0,
    };
  },
  computed: {},
  watch: {
    options: {
      handler () {
        this.getSolicitudServicioPendientes_()
      },
      deep: true,
    },
  },
  mounted () {
    //this.getSolicitudServicioPendientes_();
  },
  methods: {
    async getSolicitudServicioPendientes_ () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getSolicitudServicioPendientesPaginated(self.options, self.search);

        //console.log("DATATABLE: " + response.data.data);

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.numberOfItemsOnServer = response.data.data.total
              self.items = response.data.data.lst;
            } else {
              self.snackbarError = true;
              self.textoError = response.data.message;
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;
        self.snackbarError = true;
        self.textoError = e;
      }
    },
    consultarSolicitud (item) {
      this.itemSelected = item;
      this.dialog = true;
    },
    closeDialog () {
      this.dialog = false;
    },
    getDateFormated (date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY hh:mm a");
      }
    },
  },
};
</script>
